import request from '@/utils/request'

 //保存反馈
 export const submitHelp = (data)=> {
  return request({
    url: '/api/saveFeedback',
    method: 'POST',
    data:{
        ...data     
    }
  })
}
